import plantListSaga from 'modules/Plants/saga/list';
import plantDetailsSaga from 'modules/Plants/saga/details';
import { SagaIterator } from 'redux-saga';
import { fork } from 'redux-saga/effects';

export default function* plantSaga(): SagaIterator {
  yield fork(plantListSaga);
  yield fork(plantDetailsSaga);
}
